export default __webpack_public_path__ + "static/micro-1101ffe362230731de4ec30ccadcfe24.png";